import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import BrandLogo from '@/components/atoms/BrandLogo';
import { Button } from '@/components/ui/button';
import { cn } from '@/lib/utils';
import { PAGE_PATHS } from '@/routes/const';
import DesktopQrCodeGate from './DesktopQrCodeGate';

/**
 * lg(≥1024px) 전체 화면 배경 위의 투명한 좌측 브랜드 패널.
 * kdermpass 의 앱 다운로드 자리는 "휴대폰에서 이어보기" QR + Host 상담 CTA 로 대체한다 (웹 전용).
 */
export default function BrandPanel() {
  const { t, i18n } = useTranslation();
  const currentUrl =
    typeof window === 'undefined'
      ? 'https://dev.glowpass.kr'
      : window.location.href;

  return (
    <aside className="sticky top-0 hidden h-dvh flex-1 flex-col justify-between overflow-hidden p-12 lg:flex">
      <BrandLogo size="large" className="self-start rounded-2xl bg-gp-cream" />
      <div className="max-w-md rounded-3xl bg-gp-cream/95 p-6">
        <h2
          className={cn(
            'font-display text-[clamp(40px,4.2vw,64px)] font-semibold tracking-tight text-gp-pink-800',
            i18n.resolvedLanguage === 'zh-CN'
              ? 'leading-normal'
              : 'leading-[1.15]',
          )}
        >
          {t('brand.tagline')}
        </h2>
        <p className="mt-5 text-caption font-semibold tracking-[0.2em] text-gp-olive-700">
          {t('brand.pillars')}
        </p>
        <p className="mt-8 text-body text-gp-pink-800">{t('brand.script')}</p>
      </div>
      <div className="flex flex-wrap items-end gap-4">
        <div className="rounded-[var(--radius-card)] bg-white p-3 shadow-glow">
          <DesktopQrCodeGate value={currentUrl} />
          <p className="mt-2 text-center text-caption text-gp-ink-600">
            {t('brand.continueOnPhone')}
          </p>
        </div>
        <Button asChild size="lg">
          <Link to={PAGE_PATHS.CHAT}>{t('brand.talkToHost')}</Link>
        </Button>
      </div>
    </aside>
  );
}
